import * as GETTER from './getter-types'

export default {
    [GETTER.HAS]: (state) => (payload) => payload.type in state && payload.name in state[payload.type],
    [GETTER.GET]: (state) => (payload) => payload.type in state && payload.name in state[payload.type] ? state[payload.type][payload.name] : undefined,
    [GETTER.HAS_TYPE]: (state) => (payload) => payload.type in state
}
